import UserStore from "../../../store/user-store";
import PaymnetStore from "../../../store/paymnet-store";
import axios from "axios";
import {apiClient} from "../../../AxiosConfig";

const apiUrl = process.env.REACT_APP_API_URL;
const TG_WEB_APP = window.Telegram.WebApp


export const cryptomusCreateInvoice = async (planId, configId) => {
    const body = {
        "plan_id": planId,
        "plan_config_id": configId
    }
    if (UserStore.partnerId) {
        body["partner_id"] =UserStore.partnerId
    }
    apiClient.post('/v1/invoices/cryptomus-invoice', {
        ...body
    }).then(data => {
        if (data.status === 200 && PaymnetStore.isPaymentProcessed) {
            PaymnetStore.setPaymentUrl(data.data?.payment_url)
            PaymnetStore.setTxId(data.data?.order_id)
            PaymnetStore.setIsPaymentUrlOpened(true)
            TG_WEB_APP.openLink(data.data?.payment_url)

        }
    })
}